/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendActiveTariffPlanDto } from '../models/backend-active-tariff-plan-dto';
import { BackendPaginatedTariffPlanListDto } from '../models/backend-paginated-tariff-plan-list-dto';
import { BackendPaymentDto } from '../models/backend-payment-dto';
import { BackendSubscriptionDto } from '../models/backend-subscription-dto';
import { subscriptionActivePartialUpdate } from '../fn/subscription/subscription-active-partial-update';
import { subscriptionActivePartialUpdate$FormData } from '../fn/subscription/subscription-active-partial-update-form-data';
import { SubscriptionActivePartialUpdate$FormData$Params } from '../fn/subscription/subscription-active-partial-update-form-data';
import { SubscriptionActivePartialUpdate$Params } from '../fn/subscription/subscription-active-partial-update';
import { subscriptionActivePartialUpdate$XWwwFormUrlencoded } from '../fn/subscription/subscription-active-partial-update-x-www-form-urlencoded';
import { SubscriptionActivePartialUpdate$XWwwFormUrlencoded$Params } from '../fn/subscription/subscription-active-partial-update-x-www-form-urlencoded';
import { subscriptionActiveRetrieve } from '../fn/subscription/subscription-active-retrieve';
import { SubscriptionActiveRetrieve$Params } from '../fn/subscription/subscription-active-retrieve';
import { subscriptionActiveUpdate } from '../fn/subscription/subscription-active-update';
import { subscriptionActiveUpdate$FormData } from '../fn/subscription/subscription-active-update-form-data';
import { SubscriptionActiveUpdate$FormData$Params } from '../fn/subscription/subscription-active-update-form-data';
import { SubscriptionActiveUpdate$Params } from '../fn/subscription/subscription-active-update';
import { subscriptionActiveUpdate$XWwwFormUrlencoded } from '../fn/subscription/subscription-active-update-x-www-form-urlencoded';
import { SubscriptionActiveUpdate$XWwwFormUrlencoded$Params } from '../fn/subscription/subscription-active-update-x-www-form-urlencoded';
import { subscriptionPaymentCreate } from '../fn/subscription/subscription-payment-create';
import { subscriptionPaymentCreate$FormData } from '../fn/subscription/subscription-payment-create-form-data';
import { SubscriptionPaymentCreate$FormData$Params } from '../fn/subscription/subscription-payment-create-form-data';
import { SubscriptionPaymentCreate$Params } from '../fn/subscription/subscription-payment-create';
import { subscriptionPaymentCreate$XWwwFormUrlencoded } from '../fn/subscription/subscription-payment-create-x-www-form-urlencoded';
import { SubscriptionPaymentCreate$XWwwFormUrlencoded$Params } from '../fn/subscription/subscription-payment-create-x-www-form-urlencoded';
import { subscriptionPaymentNotificationCreate } from '../fn/subscription/subscription-payment-notification-create';
import { SubscriptionPaymentNotificationCreate$Params } from '../fn/subscription/subscription-payment-notification-create';
import { subscriptionPaymentRequisitesRetrieve } from '../fn/subscription/subscription-payment-requisites-retrieve';
import { SubscriptionPaymentRequisitesRetrieve$Params } from '../fn/subscription/subscription-payment-requisites-retrieve';
import { subscriptionTariffPlanActiveRetrieve } from '../fn/subscription/subscription-tariff-plan-active-retrieve';
import { SubscriptionTariffPlanActiveRetrieve$Params } from '../fn/subscription/subscription-tariff-plan-active-retrieve';
import { subscriptionTariffPlanList } from '../fn/subscription/subscription-tariff-plan-list';
import { SubscriptionTariffPlanList$Params } from '../fn/subscription/subscription-tariff-plan-list';

@Injectable({ providedIn: 'root' })
export class BackendApiSubscriptionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `subscriptionActiveRetrieve()` */
  static readonly SubscriptionActiveRetrievePath = '/api/subscription/active/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActiveRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionActiveRetrieve$Response(
    params?: SubscriptionActiveRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActiveRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActiveRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionActiveRetrieve(
    params?: SubscriptionActiveRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActiveRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /** Path part for operation `subscriptionActiveUpdate()` */
  static readonly SubscriptionActiveUpdatePath = '/api/subscription/active/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActiveUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionActiveUpdate$Response(
    params?: SubscriptionActiveUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActiveUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActiveUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionActiveUpdate(
    params?: SubscriptionActiveUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActiveUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActiveUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  subscriptionActiveUpdate$XWwwFormUrlencoded$Response(
    params?: SubscriptionActiveUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActiveUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActiveUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  subscriptionActiveUpdate$XWwwFormUrlencoded(
    params?: SubscriptionActiveUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActiveUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActiveUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  subscriptionActiveUpdate$FormData$Response(
    params?: SubscriptionActiveUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActiveUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActiveUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  subscriptionActiveUpdate$FormData(
    params?: SubscriptionActiveUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActiveUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /** Path part for operation `subscriptionActivePartialUpdate()` */
  static readonly SubscriptionActivePartialUpdatePath = '/api/subscription/active/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActivePartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionActivePartialUpdate$Response(
    params?: SubscriptionActivePartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActivePartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActivePartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionActivePartialUpdate(
    params?: SubscriptionActivePartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActivePartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActivePartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  subscriptionActivePartialUpdate$XWwwFormUrlencoded$Response(
    params?: SubscriptionActivePartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActivePartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActivePartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  subscriptionActivePartialUpdate$XWwwFormUrlencoded(
    params?: SubscriptionActivePartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActivePartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionActivePartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  subscriptionActivePartialUpdate$FormData$Response(
    params?: SubscriptionActivePartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
    return subscriptionActivePartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionActivePartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  subscriptionActivePartialUpdate$FormData(
    params?: SubscriptionActivePartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendSubscriptionDto> {
    return this.subscriptionActivePartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSubscriptionDto>): BackendSubscriptionDto => r.body),
    );
  }

  /** Path part for operation `subscriptionPaymentCreate()` */
  static readonly SubscriptionPaymentCreatePath = '/api/subscription/payment/';

  /**
   * Создает платеж и возвращает ссылку для оплаты.
   *
   * :param request: Запрос с данными о платеже
   * :return: Ссылка для оплаты
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionPaymentCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionPaymentCreate$Response(
    params?: SubscriptionPaymentCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaymentDto>> {
    return subscriptionPaymentCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создает платеж и возвращает ссылку для оплаты.
   *
   * :param request: Запрос с данными о платеже
   * :return: Ссылка для оплаты
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionPaymentCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionPaymentCreate(
    params?: SubscriptionPaymentCreate$Params,
    context?: HttpContext,
  ): Observable<BackendPaymentDto> {
    return this.subscriptionPaymentCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaymentDto>): BackendPaymentDto => r.body),
    );
  }

  /**
   * Создает платеж и возвращает ссылку для оплаты.
   *
   * :param request: Запрос с данными о платеже
   * :return: Ссылка для оплаты
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionPaymentCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  subscriptionPaymentCreate$XWwwFormUrlencoded$Response(
    params?: SubscriptionPaymentCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaymentDto>> {
    return subscriptionPaymentCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создает платеж и возвращает ссылку для оплаты.
   *
   * :param request: Запрос с данными о платеже
   * :return: Ссылка для оплаты
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionPaymentCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  subscriptionPaymentCreate$XWwwFormUrlencoded(
    params?: SubscriptionPaymentCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendPaymentDto> {
    return this.subscriptionPaymentCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaymentDto>): BackendPaymentDto => r.body),
    );
  }

  /**
   * Создает платеж и возвращает ссылку для оплаты.
   *
   * :param request: Запрос с данными о платеже
   * :return: Ссылка для оплаты
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionPaymentCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  subscriptionPaymentCreate$FormData$Response(
    params?: SubscriptionPaymentCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaymentDto>> {
    return subscriptionPaymentCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создает платеж и возвращает ссылку для оплаты.
   *
   * :param request: Запрос с данными о платеже
   * :return: Ссылка для оплаты
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionPaymentCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  subscriptionPaymentCreate$FormData(
    params?: SubscriptionPaymentCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendPaymentDto> {
    return this.subscriptionPaymentCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaymentDto>): BackendPaymentDto => r.body),
    );
  }

  /** Path part for operation `subscriptionPaymentNotificationCreate()` */
  static readonly SubscriptionPaymentNotificationCreatePath = '/api/subscription/payment/notification/';

  /**
   * Обрабатывает уведомление о платеже приходящее от юкассы.
   *
   * :param request: Запрос с данными уведомления
   * :return: Результат обработки уведомления
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionPaymentNotificationCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionPaymentNotificationCreate$Response(
    params?: SubscriptionPaymentNotificationCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return subscriptionPaymentNotificationCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обрабатывает уведомление о платеже приходящее от юкассы.
   *
   * :param request: Запрос с данными уведомления
   * :return: Результат обработки уведомления
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionPaymentNotificationCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionPaymentNotificationCreate(
    params?: SubscriptionPaymentNotificationCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.subscriptionPaymentNotificationCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `subscriptionPaymentRequisitesRetrieve()` */
  static readonly SubscriptionPaymentRequisitesRetrievePath = '/api/subscription/payment/requisites/';

  /**
   * Просмотр реквизитов.
   *
   * :param request: Запрос
   * :return: Реквизиты платежа
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionPaymentRequisitesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionPaymentRequisitesRetrieve$Response(
    params?: SubscriptionPaymentRequisitesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return subscriptionPaymentRequisitesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Просмотр реквизитов.
   *
   * :param request: Запрос
   * :return: Реквизиты платежа
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionPaymentRequisitesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionPaymentRequisitesRetrieve(
    params?: SubscriptionPaymentRequisitesRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.subscriptionPaymentRequisitesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `subscriptionTariffPlanList()` */
  static readonly SubscriptionTariffPlanListPath = '/api/subscription/tariff_plan/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionTariffPlanList()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionTariffPlanList$Response(
    params?: SubscriptionTariffPlanList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedTariffPlanListDto>> {
    return subscriptionTariffPlanList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionTariffPlanList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionTariffPlanList(
    params?: SubscriptionTariffPlanList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedTariffPlanListDto> {
    return this.subscriptionTariffPlanList$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaginatedTariffPlanListDto>): BackendPaginatedTariffPlanListDto => r.body),
    );
  }

  /** Path part for operation `subscriptionTariffPlanActiveRetrieve()` */
  static readonly SubscriptionTariffPlanActiveRetrievePath = '/api/subscription/tariff_plan/active/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionTariffPlanActiveRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionTariffPlanActiveRetrieve$Response(
    params?: SubscriptionTariffPlanActiveRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActiveTariffPlanDto>> {
    return subscriptionTariffPlanActiveRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionTariffPlanActiveRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionTariffPlanActiveRetrieve(
    params?: SubscriptionTariffPlanActiveRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActiveTariffPlanDto> {
    return this.subscriptionTariffPlanActiveRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActiveTariffPlanDto>): BackendActiveTariffPlanDto => r.body),
    );
  }
}
